import TableHeader from "../TableHeader";

import { Row, TableWrapper } from "./DesktopTable.styled";

const DesktopTable = ({
  data,
  headerData,
  renderRowContent,
  showStatus,
  gridSettings,
}) => {
  return (
    <TableWrapper showStatus={showStatus} gridSettings={gridSettings}>
      {headerData.map((header, i) => (
        <TableHeader key={i}>{header}</TableHeader>
      ))}

      {data?.map((item, index) => (
        <Row key={index}>{renderRowContent(item, index)}</Row>
      ))}
    </TableWrapper>
  );
};

export default DesktopTable;
